module.exports = __webpack_public_path__ + "media/images/instagram-copper-a04085727c7fec62d7e4326e34237e8d.svg";